import { timeOfDayName } from '@aytm/lib/common/time'
import { ChatAssistant } from '../../types'
import SkipperSuggestedPrompts from './SkipperSuggestedPrompts'

import styles from './SkipperGreetingCard.module.scss'

export type SkipperGreetingCardProps = {
  assistant: ChatAssistant
}

export default function SkipperGreetingCard({ assistant }: SkipperGreetingCardProps) {
  return (
    <div className={styles.SkipperGreetingCard}>
      <div className={styles.SkipperGreetingCard__title}>Good {timeOfDayName()}, Skipper is here</div>
      <div className={styles.SkipperGreetingCard__text}>
        How can I help you{assistant.userName ? `, ${assistant.userName.split(' ', 2)[0]}` : ''}?
      </div>
      <SkipperSuggestedPrompts assistant={assistant} />
    </div>
  )
}
